import { Component, effect, inject } from '@angular/core';
import { LocaleService } from 'src/app/services/locale';
import { VideoComponent } from '../../shared/video';
import { VideoService } from 'src/app/services/video';
@Component({
  selector: 'app-training',
  imports: [VideoComponent],
  template: `
    <div class="text-xl futura">
      {{ locale.profile.heading_video_available }}
    </div>

    <div class="text-[#616161] mt-2 w-full">
      {{ locale.profile.subheading_video_available }}
    </div>
      <app-video [training]="true" [videos]="videos"></app-video>
  `
})
export class TrainingComponent {
  localeService = inject(LocaleService);
  locale = this.localeService.locale();
  videos = inject(VideoService).getVideos();

  constructor() {
    effect(() => {
      this.locale = this.localeService.locale();
    });
  }
}
